<template>
    <section>
      <h3 class="centered-text">You don’t need to be home for delivery.</h3>

      <p class="centered-text">Simply &ldquo;Mark an X&rdquo; on a 4&Prime; &times; 4&Prime; area of your driveway where you would like the bag placed. Keep in mind to allow enough space for your car to be parked.</p>

      <div class="delivery-date">
        <h3>Your order will arrive BEFORE or ON</h3>

        <ul class="delivery-date-options">
          <li v-for="date in deliveryDates" :key="date">
            <input type="radio" :id="date" name="deliveryDate" :value="date" v-model="deliveryDate">
            <label :for="date">{{ moment(date).format('dddd MMM. Do, YYYY') }}</label>
          </li>
        </ul>
        <!-- <h4 class="centered-text confirmation-text">PLEASE CONFIRM your order will arrive between TOMORROW and the SELECTED DATE above.</h4> -->
      </div>
    </section>
</template>

<script>
import OrderSummary from '../orderSummary.vue';

export default {
  name: 'DeliveryDate',

  components: {
    OrderSummary,
  },

  computed: {
    /**
     * List of three upcoming delivery dates
     */
    deliveryDates() {
      return this.$store.state.deliveryDates;
    },

    deliveryDate: {
      get() {
        return this.$store.state.deliveryDate;
      },
      set(value) {
        this.$store.commit('setProperties', { deliveryDate: value });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
  .delivery-date {
    background-color: #F4F4F4;
    border-radius: 1em;
    padding: 2.62em;
    margin-bottom: 1.62em;
  }

  .delivery-date h3 {
    margin-top: 0;
    color: #009245;
    text-align: center;
  }

  .radio-button {
  display: inline-flex;
  width: 100%;
  margin: 0.62em 0;

  label {
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    font-size: 1.24em;

    span {
      margin: 0.15em 0;
    }
  }
}

[type="radio"] {
  margin: 0.38em 0.62em;
  display: none;

  & + label {
    position: relative;
    padding-left: 33px;

    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: -2px;
      width: 22px;
      height: 22px;
      border: 3px solid #009245;
      border-radius: 100%;
      background-color: white;
    }

    &:after {
      content: '';
      width: 16px;
      height: 16px;
      background: #009245;
      position: absolute;
      top: 4px;
      left: 6px;
      border-radius: 100%;
      transition: all 0.24s ease;
    }
  }

  &:checked {
    & + label:after {
      opacity: 1;
      transform: scale(1);
    }

    &:active + label:after {
      opacity: 1;
      transform: scale(0.83);
    }
  }

  &:not(:checked) {
    & + label:after {
      opacity: 0;
      transform: scale(0);
    }

    &:active + label:after {
      opacity: 1;
      transform: scale(0.38);
    }
  }
}

.delivery-date-options {
  margin: 0;
  padding: 0;
  list-style-type: none;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;

  li {
    flex: 1;
    min-width: 240px;
    margin: .38em 0;
  }
}

.confirmation-text {
  margin-top: 4.24em;
  color:#ED3337;
  font-style: italic;
}
</style>
